import React, {Component} from "react";
import "./PanelGroup.scss";
import Loading from "./Loading";
import {cx} from "../lib/ClassSet";

class PanelGroup extends Component {

  render() {

    let {title, expanded} = this.props;
    let content = expanded ? this.props.children : null;

    const classes = cx({
      "PanelGroup": true,
      "s-expanded": expanded,
      "s-collapsed": !expanded
    })

    let loadingElement = null;
    if (this.props.showLoading) {
      loadingElement = <Loading key="loading" />
    }

    return (
      <div className={classes}>
        <div className="header" onClick={this.props.onToggleContent}>
          <div className="arrow" />
          <div className="title">{title}</div>
          {loadingElement}
        </div>
        <div className="content">
          {content}
        </div>
      </div>
    )
  }

}

PanelGroup.defaultProps = {
  title: "Title",
  expanded: true,
  showLoading: false,
  onToggleContent: () => null
}

export default PanelGroup;